export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_ACTIVE_PAGE = "SET_ACTIVE_PAGE";
export const OPEN_USER_PROFILE_SIDEBAR = 'OPEN_USER_PROFILE_SIDEBAR';
export const CLOSE_USER_PROFILE_SIDEBAR = 'CLOSE_USER_PROFILE_SIDEBAR';
export const SET_CONVERSATION_NAME_IN_OPEN_CHAT = 'SET_CONVERSATION_NAME_IN_OPEN_CHAT';
export const SET_LAYOUT_MODE = "SET_LAYOUT_MODE";